// Copyright (c) 2016 Deere & Company

import {createStatusChangeRequest} from './status-change-request';
import {deleteFileFromStatusChangeRequest} from './delete-file';
import {fetchCountries} from './countries';
import {fetchPrimaryProductStatuses} from './primary-product-statuses';
import {fetchStatesInCountry} from './states-in-country';
import {goToPreviousView} from './../../shared/action-creators/go-to-previous-view';
import {resetStatusChangeRequestState} from './reset-status-change-request-state';
import {setStatusChangeRequestState} from './set-status-change-request-state';
import {updateProduct} from './product';
import {updateSelectedMachinePutBack} from './update-selected-machine-put-back';
import {updateStatusChangeRequest} from './update-status-change-request';
import {updateStatusChangeRequestForm} from './status-change-request-form';
import {updateStatusChangeRequestObject} from './update-status-change-request-object';

export default {
    createStatusChangeRequest,
    deleteFileFromStatusChangeRequest,
    fetchCountries,
    fetchPrimaryProductStatuses,
    fetchStatesInCountry,
    goToPreviousView,
    resetStatusChangeRequestState,
    setStatusChangeRequestState,
    updateProduct,
    updateSelectedMachinePutBack,
    updateStatusChangeRequest,
    updateStatusChangeRequestForm,
    updateStatusChangeRequestObject
};



// WEBPACK FOOTER //
// ./src/product/status-change-request/action-creators/index.js